import { apiGet, apiPost, apiPostVoid, getFullyQualifiedAPIUrl } from "@/core/api";
import { sessionState } from "@/core/session";
import { User } from "@minicity/core";
export const apiTasks = {
    getAssignedTasksForNetwork: () => apiGet(`assignedTasks?cutoffDays=90`),
    getAssignedTasksForPartner: (partnerId) => apiGet(`partners/${partnerId}/assignedTasks`),
    getAssignedTasksForPartnerUser: (partnerId, partnerUserId) => apiGet(`partners/${partnerId}/partnerUsers/${partnerUserId}/assignedTasks`),
    getMyAssignedTasks: () => {
        var _a, _b;
        switch ((_a = sessionState.session) === null || _a === void 0 ? void 0 : _a.user.role) {
            case User.Role.NETWORK_ADMIN: return apiTasks.getAssignedTasksForNetwork();
            case User.Role.PARTNER_ADMIN: return apiTasks.getAssignedTasksForPartner(sessionState.session.partnerId);
            case User.Role.PARTNER_USER: return apiTasks.getAssignedTasksForPartnerUser(sessionState.session.partnerId, sessionState.session.user.id);
            default: throw new Error(`Unsupported user type: ${(_b = sessionState.session) === null || _b === void 0 ? void 0 : _b.user.role}`);
        }
    },
    addComment: (taskId, message, attachments, notifyCaseworker) => apiPost(`tasks/${taskId}/comments`, { message: message, attachments: attachments, notifyCaseworker: notifyCaseworker }),
    getComments: (taskId) => apiGet(`tasks/${taskId}/comments`),
    getCommentAttachmentViewLink: (taskId, commentId, attachmentId) => apiGet(`tasks/${taskId}/comments/viewToken`)
        .then(viewToken => getFullyQualifiedAPIUrl(`tasks/${taskId}/comments/${commentId}/attachments/${attachmentId}?token=${encodeURIComponent(viewToken)}`)),
    markCompleted: (taskId, d) => apiPostVoid(`tasks/${taskId}:markCompleted`, d),
    submitForReview: (taskId) => apiPostVoid(`tasks/${taskId}:submitForReview`, null),
    cancel: (taskId, d) => apiPostVoid(`tasks/${taskId}:cancel`, d),
    reopen: (taskId) => apiPostVoid(`tasks/${taskId}:reopen`, null),
};
